import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorkReportPhotosDt from '@/services/dataTransferModules/workReportPhotosDt'

export default function useWorkReportPhotos(params = {}) {
	const workReportPhotosDt = new WorkReportPhotosDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingWorkReportPhoto: {
			title: '',
			description: '',
			example: '',
		},
		fieldsToPatch: ['title', 'description', 'photo_file_id'],
	}

	const {
		loadEntityFlags: flags,

		entities: workReportPhotos,
		getEntities: getWorkReportPhotos,

		createEntity: createWorkReportPhoto,

		entity: workReportPhoto,
		getEntity: getWorkReportPhoto,

		patchEntity: putWorkReportPhoto,
		updateEntity: updateWorkReportPhotos,

		deleteEntity: deleteWorkReportPhoto,
	} = useBlProviders(
		workReportPhotosDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Photo report type loading error'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Work report photos editing error'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Error when deleting type of photo reports'),
			},
			params,
		),
	)

	return {
		flags,
		defaults,
		workReportPhotos,
		workReportPhoto,
		getWorkReportPhotos,
		getWorkReportPhoto,
		createWorkReportPhoto,
		putWorkReportPhoto,
		updateWorkReportPhotos,
		deleteWorkReportPhoto,
	}
}
